import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsConditions = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-16 text-gray-300">
        <h1 className="text-4xl font-bold text-white mb-8">Terms and Conditions</h1>
        <p className="text-sm text-gray-500 mb-12">Last Updated: May 2, 2026</p>

        <section className="space-y-12">
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By accessing and using PlayConnect, you agree to be bound by these Terms and Conditions. 
              If you do not agree with any part of these terms, you must not use the platform.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">2. User Conduct</h2>
            <p className="leading-relaxed">
              Users are expected to behave professionally and respectfully during matches organized via the platform. 
              PlayConnect reserves the right to suspend or ban accounts that violate community standards.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">3. Responsibility</h2>
            <p className="leading-relaxed">
              PlayConnect is a matchmaking platform. We are not responsible for any injuries, accidents, or disputes 
              that occur during physical matches organized through our service. Players participate at their own risk.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">4. Account Security</h2>
            <p className="leading-relaxed">
              You are responsible for maintaining the confidentiality of your account and password. 
              You agree to accept responsibility for all activities that occur under your account.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;
